/* @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import Colors from "util/colors";

const colors = Colors.get();

const Wrapper = styled("div")({
  padding: "8px 10px 8px 10px",
  margin: "5px 0px 5px 0px",
  backgroundColor: colors.white,
  borderRadius: "3px",
});
const Title = styled("div")({
  display: "flex",
  alignItems: "center",
  lineHeight: "20px",
  marginBottom: "6px",
  paddingLeft: "2.68px",
  paddingRight: "2.68px",
});
const Label = styled("div")({
  fontSize: "13px",
  fontWeight: 600,
  color: colors.main,
  lineHeight: "20px",
  marginLeft: "6px",
});
const Description = styled("div")({
  display: "flex",
  alignItems: "center",
  fontSize: "12px",
  fontWeight: 300,
});

/**
 * プロパティ定義
 */
type Props = {
  /** トイレ種別 */
  type: string;
  /** トイレアイコン */
  icon: string;
  /** トイレに関する説明文 */
  description: string;
};

/**
 * リストアイテム（トイレ説明）
 * @param param コンポーネントのProps
 */
export default function UsageLabel({
  type,
  icon,
  description,
}: Props) {
  return (
    <Wrapper>
      <Title>
        <img src={`data:image/svg+xml;utf8,${encodeURIComponent(icon)}`} alt="icon"/>
        <Label>{type}</Label>
      </Title>
      <Description>
        {description}
      </Description>
    </Wrapper>
  );
}
